const PREVIEWABLE_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp'];
const PREVIEWABLE_CONTENT_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp'
];

/** Whether DocumentViewerDialog's iframe can render this file type in-page. */
export function isPreviewableDocument(
  fileName: string,
  contentType?: string
): boolean {
  if (contentType && PREVIEWABLE_CONTENT_TYPES.includes(contentType)) {
    return true;
  }
  const extension = fileName.split('.').pop()?.toLowerCase();
  return extension ? PREVIEWABLE_EXTENSIONS.includes(extension) : false;
}

/**
 * Content type of what a lead document's url actually serves. Converted
 * documents keep their original name and content_type but point at a PDF.
 */
export function servedContentType(doc: {
  content_type?: string;
  pdf_conversion_status?: string;
}): string | undefined {
  return doc.pdf_conversion_status === 'completed'
    ? 'application/pdf'
    : doc.content_type;
}
